import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { show_eventTimeLine, Set_viewOrder_events } from "../../../../Redux/actions/actionNames";
import Eventitem from "./item";
import AudioItem from "./audioItem";
import close from "../../../../assets/close.svg";
import addSquare from "../../../../assets/add-square.svg";

import momentJalaali from "moment-jalaali";
import { get_calendarType } from "../../../../helper/UserData/userdate";
import styles from './style.module.css';
import { OrderGetEventsAction } from "../../../../Redux/actions/actions";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEvent: null,
      list: [
      ]
    }
    this.setEvents = this.setEvents.bind(this)
  }

  eventShowHandler = () => {
    this.props.dispatch(show_eventTimeLine(false))
  }

  eventOnclick = (id, cordinate) => {
    this.setState({
      selectedEvent: id
    })
    if (cordinate) {
      this.props.dispatch(Set_viewOrder_events({ activeEventCordinator: cordinate }))

    } else {
      this.props.dispatch(Set_viewOrder_events({ activeEventCordinator: null }))

    }

  }

  componentDidMount = () => {
    this.setEvents()
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.orderId != this.props.orderId){
      if(nextProps.orderId){
        this.props.dispatch(Set_viewOrder_events({
          loading: true,
          data: [],
        }))
        this.props.dispatch(OrderGetEventsAction(this.props.dispatch, nextProps.orderId))
      }
    }
    this.setEvents(nextProps)

  }

  setEvents = (nextProps) => {

    if (this.state.list.length != (nextProps ? nextProps.data.length : this.props.data.length)) {
      let data = nextProps ? nextProps.data : this.props.data;

      const groups = data.sort((a, b) => a.createdAt - b.createdAt).reduce((groups, game) => {
        const date = momentJalaali(game.createdAt).locale(get_calendarType()).format("DD/MM/YYYY")
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(game);
        return groups;
      }, {});

      const groupArrays = Object.keys(groups).map((date) => {
        return {
          date,
          events: groups[date]
        };
      });
      this.setState({
        list: groupArrays
      })
    }
  }

  render() {


    return (
      <div style={{ width: "100%", height: "100%" }}>
        <div className={styles.EventTimeLine_Header}>
          <img onClick={this.eventShowHandler} className={styles.close} src={close} />
          <span className={styles.eventsTitle}> <Trans i18nKey={"Events"}> </Trans> </span>
          <img onClick={this.props.showCreateDialoge} className={styles.createEvent} src={addSquare} />


        </div>

        <div className={styles.EventTimeLine_ListContainer}>

          {this.state.list.length == 0 && <span className="NotravelsListText" style={{color:"black",fontSize:"15px",marginTop:"150px"}}>
            <Trans i18nKey={"fetchingdata"}> </Trans>{" "}
          </span>}

          {this.state.list.map((item, i) => {

            {
              return item.events.map((itemx, ii) => {
                return ["IncomingCall", "OutgoingCall"].indexOf(itemx.type) > -1 ?
                  <AudioItem firstItemInArray={ii == 0} selectedEvent={this.state.selectedEvent} onClick={this.eventOnclick} {...itemx} id={String(String(i) + String(ii))} isFirst={ii == 0 && i == 0} isLast={ii == item.events.length - 1 && i == this.state.list.length - 1} />
                  :
                  <Eventitem firstItemInArray={ii == 0} selectedEvent={this.state.selectedEvent} onClick={this.eventOnclick} {...itemx} id={String(String(i) + String(ii))} isFirst={ii == 0 && i == 0} isLast={ii == item.events.length - 1 && i == this.state.list.length - 1} />
              })
            }


          })}



        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  showEventTimeLine: state.ViewTravel.eventTimeLine.show,
  loading: state.ViewTravel.eventTimeLine.loading,
  data: state.ViewTravel.eventTimeLine.data,
  error: state.ViewTravel.eventTimeLine.error,
  orderId:state.ViewTravel.pureData ? state.ViewTravel.pureData.id : null,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
